import { render, staticRenderFns } from "./ChooseCategory.vue?vue&type=template&id=570d3796&scoped=true"
import script from "./ChooseCategory.vue?vue&type=script&lang=js"
export * from "./ChooseCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570d3796",
  null
  
)

export default component.exports